import React from 'react';
import styles from './ProjectSkillTags.module.css';

const ProjectSkillTags = ({ skills }) => {
  return (
    <div className={styles.tags}>
      {Object.entries(skills).map(([skill, iconName], skillIndex) => (
        <span key={skillIndex} className={styles.tag}>
          {iconName && (
            <img
              src={`/skill_icons/${iconName}.svg`}
              alt={`${skill} icon`}
              className={styles.icon}
            />
          )}
          <span className={styles.skillText}>{skill}</span>
        </span>
      ))}
    </div>
  );
};

export default ProjectSkillTags;
